import { AccountForPlicPendingPhotos } from './graphql';

export const PLIC_PHOTOS_EXPORT_START = 'plic-books/PLIC_PHOTOS_EXPORT_START';
export const PLIC_PHOTOS_EXPORT_PROGRESS =
  'plic-books/PLIC_PHOTOS_EXPORT_PROGRESS';
export const PLIC_PHOTOS_EXPORT_COMPLETE =
  'plic-books/PLIC_PHOTOS_EXPORT_COMPLETE';

const POLLING_INTERVAL = 2500;

export const plicPhotosExportStart = ({ interval, exportedPhotosCount }) => {
  return {
    type: PLIC_PHOTOS_EXPORT_START,
    interval,
    exportedPhotosCount,
  };
};

export const plicPhotosExportComplete = () => {
  return { type: PLIC_PHOTOS_EXPORT_COMPLETE };
};

export const plicPhotosExportProgress = ({ pendingPhotosCount }) => {
  return { type: PLIC_PHOTOS_EXPORT_PROGRESS, pendingPhotosCount };
};

const onAlbumPool = async ({ dispatch, client }) => {
  try {
    const { data: { me: account } = {} } = await client.query({
      query: AccountForPlicPendingPhotos,
      fetchPolicy: 'network-only',
    });

    if (account?.plic_pending_photo_uploads_count === 0) {
      dispatch(plicPhotosExportComplete());
    } else {
      dispatch(
        plicPhotosExportProgress({
          pendingPhotosCount: account?.plic_pending_photo_uploads_count,
        }),
      );
    }
  } catch (e) {
    // Ignore errors, next poll will probably take care of it anyway.
  }
};

export const plicPhotosExport =
  ({ client, exportedPhotosCount }) =>
  async dispatch => {
    const interval = setInterval(onAlbumPool, POLLING_INTERVAL, {
      dispatch,
      client,
    });

    dispatch(plicPhotosExportStart({ interval, exportedPhotosCount }));
  };
